import { fetchWrapper } from "../Helpers/fetch-wrapper";

const getActiveElrs = async () => {
    const data = await fetchWrapper.get(
        `${process.env.REACT_APP_API_ENDPOINT}/activeElr/active_elrs`
    );

    return data;
}

export const ElrsService = {
    getActiveElrs
}